module.exports = __webpack_public_path__ + "static/media/Apple iPhone XR Coral.52f89b70.png";